function createSkillElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function readTags(value) {
  try { return Array.isArray(value) ? value : JSON.parse(value || '[]'); } catch { return []; }
}

function createState(message, retryAction = '') {
  const state = createSkillElement('div', 'aichat-artifact-empty aichat-workbench-state', message);
  if (retryAction) {
    const retry = createSkillElement('button', 'aichat-workbench-state-action', '点击重试');
    retry.type = 'button';
    retry.dataset.action = retryAction;
    state.append(document.createTextNode('，'), retry);
  }
  return state;
}

export function renderSkillList(root, { skills = [], loading = false, loadError = false } = {}) {
  if (!root) return;
  if (loading) return void root.replaceChildren(createState('技能加载中…'));
  if (loadError) return void root.replaceChildren(createState('技能加载失败', 'retry-load-skills'));
  if (!skills.length) return void root.replaceChildren(createState('还没有安装技能。点击右上角「技能市场」浏览并安装。'));
  root.replaceChildren(...skills.map((skill) => {
    const description = skill.user_description || skill.description || skill.prompt_template || '';
    const card = createSkillElement('article', 'aichat-skill-row');
    const body = createSkillElement('div', 'aichat-skill-row__body');
    body.append(
      createSkillElement('div', 'aichat-skill-row__name', skill.name || skill.code || '未命名技能'),
      createSkillElement('div', 'aichat-skill-row__desc', description.length > 60 ? `${description.slice(0, 60)}…` : description),
    );
    const tags = readTags(skill.tags).slice(0, 3);
    if (tags.length) {
      const tagList = createSkillElement('div', 'aichat-skill-row__tags');
      tagList.append(...tags.map((tag) => createSkillElement('span', 'aichat-skill-tag', tag)));
      body.append(tagList);
    }
    card.append(createSkillElement('div', 'aichat-skill-row__icon', String(skill.category || '📦').slice(0, 2)), body);
    return card;
  }));
}
